import PropTypes from "prop-types"
import React, { Component } from "react"
import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  FormGroup,
} from "reactstrap"
import { Formik, Form, Field } from "formik"
import * as Yup from "yup"

// Redux
import { connect } from "react-redux"
import { withRouter } from "../../helpers/withRouter"

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb"

import avatar from "../../assets/images/users/user.png"
// actions
import { editProfile } from "../../store/actions"
import { getItemFromLocalStorage } from "../../helpers/utils"

// Validation schema
const profileValidation = Yup.object().shape({
  username: Yup.string()
    .min(3, "Username must be at least 3 characters")
    .required("Username is required"),
})

class UserProfile extends Component {
  constructor(props) {
    super(props)
    this.state = { email: "", name: "", idx: 1 }
  }

  // handleValidSubmit
  handleValidSubmit = (values) => {
    this.props.editProfile(values)
  }

  componentDidMount() {
    if (getItemFromLocalStorage("user_id")) {
      const obj = JSON.parse(getItemFromLocalStorage("user_id"))
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        this.setState({
          name: obj.displayName,
          email: obj.email,
          idx: obj.uid,
        })
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        this.setState({ name: obj.username, email: obj.email, idx: obj.uid })
      }
    }
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, ss) {
    if (this.props !== prevProps) {
      const obj = JSON.parse(getItemFromLocalStorage("user_id"))
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        this.setState({
          name: obj.displayName,
          email: obj.email,
          idx: obj.uid,
        })
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        this.setState({ name: obj.username, email: obj.email, idx: obj.uid })
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumb title="uKiddiy" breadcrumbItem="Profile" />

            <Row>
              <Col lg="12">
                {this.props.error && this.props.error ? (
                  <Alert color="danger">{this.props.error}</Alert>
                ) : null}
                {this.props.success && this.props.success ? (
                  <Alert color="success">{this.props.success}</Alert>
                ) : null}

                <Card>
                  <CardBody>
                    <div className="d-flex">
                      <div className="me-3">
                        <img
                          src={avatar}
                          alt=""
                          className="avatar-md rounded-circle img-thumbnail"
                        />
                      </div>
                      <div className="align-self-center flex-1">
                        <div className="text-muted">
                          <h5>{this.state.name}</h5>
                          <p className="mb-1">{this.state.email}</p>
                          <p className="mb-0">Id no: #{this.state.idx}</p>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <h4 className="card-title mb-4">Change UserName</h4>

            <Card>
              <CardBody>
                <Formik
                  initialValues={{
                    username: this.state.name,
                    idx: this.state.idx,
                  }}
                  enableReinitialize={true}
                  validationSchema={profileValidation}
                  onSubmit={this.handleValidSubmit}
                  validateOnBlur={false}
                  validateOnChange={false}
                >
                  {({ errors }) => (
                    <Form className="form-horizontal">
                      <FormGroup className="mb-3">
                        <Label>UserName</Label>
                        <Field
                          name="username"
                          className="form-control"
                          placeholder="Enter UserName"
                          type="text"
                        />
                        {errors.username && (
                          <div className="invalid-feedback d-block">
                            {errors.username}
                          </div>
                        )}
                        <Field name="idx" type="hidden" />
                      </FormGroup>
                      <div className="text-center mt-4">
                        <Button type="submit" color="danger">
                          Edit UserName
                        </Button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

UserProfile.propTypes = {
  editProfile: PropTypes.func,
  error: PropTypes.any,
  success: PropTypes.any,
}

const mapStateToProps = state => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStateToProps, { editProfile })(UserProfile)
)
